module.exports = __webpack_public_path__ + "static/media/img_union1.56f1cc9d.jpg";